import React from "react";
import ProductSetupContainer from "../../ProductSetupContainer";

const SingleProductView = ({ match }) => {
    const { params: { productId } = {} } = match || {};
    return <ProductSetupContainer defaultProductId={productId} />;
};

export default SingleProductView;
